export const ABOUT = "about";
export const PARTNERS = "partners";
export const SPONSORS = "sponsors";
export const PLATFORM = "platform";
export const RESPONSIBILITY = "responsibility";

